<template>
    <div class="">
        <slot
            :msgError="msgError"
            :msgSuccess="msgSuccess"

            :loading="loading"
            :disableSubmit="disableSubmit"
            :isError="isError"
            :isInvalid="isInvalid"

            :response="response"
            :msg="msg"

            :notReload="notReload"
            :redirectTo="redirectTo"

            :customData="customData"
            :setCustomData="setCustomData"

            :getError="getErrorByField"

            :submit="isParentForm ? submitMultiple : submit"

            :submitMultiple="submitMultiple"
        >
            <component :is="formTag" action="#" ref="form">

            </component>
        </slot>
    </div>
</template>

<script>
    import axios from 'axios';
    import { uniqWith } from 'lodash'

    import mixinCommon from './mixinCommon';
    import mixinPubSub from './mixinPubSub';

    export default {
        mixins: [ mixinCommon, mixinPubSub ],
        props: {
            defaultFormTag: {
                type: String,
                default: 'form'
            },

            disableForm: {
                type: [String, Number, Boolean],
                default: false
            },

            isParentForm: {
                type: [String, Number, Boolean],
                default: false
            },
            isChildForm: {
                type: [String, Number, Boolean],
                default: false
            },

            ////
            defaultMsgSuccess: {
                type: String,
                default: 'Dati inviati'
            },
            defaultMsgError: {
                type: String,
                default: 'Errore nella comunicazione col server'
            },
            defaultDisableSummit: {
                type: [Boolean, Number, String],
                default: false
            },
            ////

            ////
            notReload: {
                type: [Boolean, Number, String],
                default: false
            },
            defaultRedirectTo: {
                type: [Boolean, Number, String],
                default: null
            },
            defaultReloadDelay: {
                type: [Number, String],
                default: 0
            },
            ////

            validateBeforeSend: {
                type: [Boolean, Number, String],
                default: false
            }
        },
        data() {
            return {
                data: {},

                formData: {},
                msgSuccess: this.defaultMsgSuccess,
                msgError: this.defaultMsgError,

                msg: '',

                loading: false,

                disableSubmit: this.defaultDisableSummit,

                isError: 0,

                response: null,

                //notReload: this.defaultNotReload,
                redirectTo: this.defaultRedirectTo,

                reloadDelay: this.defaultReloadDelay,

                disableRootLoading: false,

                files: null,

                isInvalid: false,

                customData: null,

                formTag: this.defaultFormTag
            };
        },
        mounted() {

        },
        watch: {
            loading: function( loading ) {
                this.triggerPageLoading( loading );

                if( this.response && this.response.status ) {
                    return;
                }

                this.disableSubmit = loading;
            }
        },
        methods: {
            getErrorByField( fields ) {
                return ( Array.isArray(fields) ? fields : [fields] )
                    .map( fieldName => {
                        try {
                            return this.response.errors[ fieldName ][0] || '';
                        }
                        catch(e) {
                            return '';
                        }
                    })
                    .filter( errorMsg => errorMsg )
                    .join('<br>')
                ;
            },

            getForm() {
                if( this.$refs.form ) {
                    return this.$refs.form;
                }
                let $form = $(this.$el).filter('form').length ? $(this.$el).filter('form') : $(this.$el).find('form');

                if( !$form.length ) {
                    $form = $(this.$el).filter('[action]').length ? $(this.$el).filter('[action]') : $(this.$el).find('[action]');
                }

                return $form;
            },

            fetchFormData() {
                let formData = {};

                this.formTag = 'form';

                let $form = $( this.getForm() );

                $form
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        try {
                            value = JSON.parse( value ) || value;
                        }
                        catch( e ) {}

                        let normName = name;
                        if( name.indexOf('[]') >= 0 ) {
                            normName = name.replace('[]', '');
                            if( !formData[ normName ] ) {
                                formData[ normName ] = [];
                            }
                            formData[ normName ].push( value );
                        }
                        else if( name.search(/\[.+\]/i) >= 0 ) {
                            normName = name.split('[').shift();

                            if( !formData[ normName ] ) {
                                formData[ normName ] = {};
                            }

                            let obj = formData[ normName ];

                            let lastKey = '';

                            const nameList = name.match(/\[[^\[^\]]+\]/gi);
                            nameList.forEach(( key, n ) => {
                                key = key.replace('[', '').replace(']', '');

                                if( !obj[ key ] || obj[ key ] == value ) {
                                    obj[ key ] = {};
                                }

                                if( n < nameList.length-1 ) {
                                    obj = obj[ key ];
                                }
                                else {
                                    lastKey = key;
                                }
                            });

                            obj[lastKey] = value;
                        }
                        else {
                            formData[ normName ] = value;
                        }
                    })
                ;

                this.formTag = this.defaultFormTag;

                if( !formData['referral'] ) {
                    formData['referral'] = document.location.href;
                }

                for( let name in formData ) {
                    if(formData[name] instanceof Object){
                        formData[name] = JSON.stringify(formData[name]);
                    }
                };

                return this.formData = formData;
            },

            reset() {
                this.formData = null;
                this.response = null;

                this.isInvalid = false;
                this.isError = false;

                this.msg = '';
                this.disableSubmit = false;
            },

            addFile( file, name ) {
                if( !(file instanceof Blob) && !name ) {
                    return false;
                }

                //var file = blobOrFile instanceof File ? blobOrFile : new File( blobOrFile, name );

                if( !this.files ) {
                    this.files = {};
                }
                if( !this.files[name] ) {
                    this.files[name] = [];
                }

                this.files[name].push( file );

                return this.files;
            },

            removeFile( name ) {
                if( this.files && this.files[name] ) {
                    this.files[name] = [];
                }
            },

            fetchFiles() {
                this.$children.forEach(( child ) => {
                    if( typeof child.getFilesToSend === 'function' ) {
                        child.getFilesToSend().forEach(( file ) => this.addFile( file, file.name ));
                    }
                });

                let files = {};
                if( this.files && Object.keys(this.files).length ) {
                    for( let name in this.files ) {
                        if( !files[name] ) {
                            files[name] = [];
                        }
                        this.files[name].forEach(( file ) => {
                            files[name].push( file );
                        });
                    }
                }

                let $files = $( this.getForm() ).find('[type="file"][name]');
                if( !$files.length ) {
                    return files;
                }

                $files.each((i, el) => {
                    let name = $(el).attr('name');

                    if( el.files && el.files.length ) {
                        for( let n in el.files ) {
                            if( el.files[n] instanceof File ) {
                                //files.push( el.files[n] );
                                if( !files[name] ) {
                                    files[ name ] = [];
                                }
                                files[ name ].push( el.files[n] );
                            }
                        }
                    }
                });

                return files;
            },

            hasFiles() {
                return this.fetchFiles().length;
            },

            sendData( formData, callback = () => {} ) {
                let _normalizeResp = ( resp = {} ) => {
                    if( typeof resp !== 'object' ) resp = {};
                    if( typeof resp.status === 'undefined' ) resp.status = 0;
                    if( !resp.msg && !resp.message ) {
                        resp.msg = resp.status ? this.msgSuccess : this.msgError;
                    }
                    else if( resp.message ) {
                        resp.msg = resp.message;
                    }

                    return resp;
                };

                let $form = this.getForm();
                let url = $form.attr('action');
                let verb = $form.attr('method');

                if( this.validateBeforeSend && !this.validate() ) {
                    return callback(
                        _normalizeResp({
                            status: 0,
                        })
                    );
                }

                if( formData instanceof FormData ) {
                    let xhr = new XMLHttpRequest();
                    xhr.open( verb, url, true );
                    xhr.onload = ( evt ) => {
                        if( evt.target.status !== 200 ) {
                            callback( _normalizeResp() );
                        }
                        else {
                            if( typeof evt.target.response !== 'object' ) {
                                try {
                                    let resp = JSON.parse( evt.target.response );
                                    callback( _normalizeResp( resp ) );
                                }
                                catch( e ) {
                                    callback( _normalizeResp() );
                                }
                            }
                            else {
                                callback( _normalizeResp( evt.target.response ) );
                            }
                        }
                    };
                    xhr.send( formData );
                }
                else {
                    axios({
                        method: verb,
                        url: url,
                        data: formData,
                    })
                        .then(( response ) => {
                            callback( _normalizeResp( response.data ) );
                        })
                        .catch(( { response = {} } = error ) => {
                            const { data: resp } = response;
                            callback( _normalizeResp( resp ) );
                        })
                    ;


                    /*$.ajax({
                        url: url,
                        method: verb,
                        data: formData,
                        success: ( resp ) => {
                            callback( _normalizeResp( resp ) );
                        },
                        error: () => {
                            callback( _normalizeResp() );
                        }
                    });*/
                }

            },

            getChildsForm( filterDisabled = true ) {
                return this.getChilds( true, child => (!filterDisabled || !+child.disableForm) && !!+child.isChildForm );
            },

            async submitMultiple( evt ) {
                if( evt && evt.prevendDefault ) {
                    evt.preventDefault();
                }

                this.loading = true;

                const asyncSubmit = async ( formComp ) => {
                    return new Promise(( resolve, reject ) => {
                        formComp.$once('response', resolve);
                        formComp.submit();
                    });
                };

                const childsForm = this.getChildsForm( true );
                async function* asyncGenerator() {
                    for( const formComp of childsForm ) {
                        yield await asyncSubmit( formComp );
                    }
                }

                for await ( const resp of asyncGenerator() ) {
                    if( !resp || !+resp.status ) {
                        this.isError = true;

                        if( resp.msg ) {
                            this.msg = resp.msg;
                        }

                        return false;
                    }
                }

                const resp = this.disableForm ? this.response : await (async () => {
                    return new Promise(( resolve, reject ) => {
                        this.$once('response', resolve);
                        this.submit();
                    });
                })();

                this.loading = false;

                return resp ? resp.status : false;
            },

            submit( evt ) {
                if( evt && evt.prevendDefault ) {
                    evt.preventDefault();
                }
                this.reset();

                let sendMode = 'formData';

                let formData = new FormData();

                let filesToSend = this.fetchFiles();
                if( !filesToSend || filesToSend.length === 0 || Object.keys(filesToSend).length === 0 ) {
                    formData = {};
                }
                else {
                    for( let name in filesToSend ) {
                        filesToSend[name].forEach(( file ) => {
                            if( formData instanceof FormData ) {
                                formData.append(name, file);
                            }
                            else {
                                formData[ name ] = file;
                            }
                        });
                    }
                }

                let dataToSend = this.fetchFormData();
                for( let name in dataToSend ) {
                    let valueToSend = dataToSend[name];
                    if( formData instanceof FormData ) {
                        formData.append( name, valueToSend );
                    }
                    else {
                        formData[ name ] = valueToSend;
                    }
                }

                this.$emit('request', formData);

                this.loading = true;
                if( this.disableForm ) {
                    const resp = this.response = {status: true};

                    this.$emit('response', resp);

                    this.loading = false;
                }
                else {
                    this.sendData(
                        formData,
                        ( resp ) => {
                            this.$emit('response', resp);
                            this.response = resp;

                            this.isError = !resp.status;
                            this.msg = resp.msg;

                            if( resp.notReload || this.notReload ) {
                                this.loading = false;

                                this.notifyBy(this.isError ? 'error' : 'success', { message: this.msg });
                            }
                            else if( resp.redirectTo || this.redirectTo ) {
                                setTimeout(() => {
                                    document.location.href = resp.redirectTo || this.redirectTo;
                                }, this.reloadDelay);
                            }
                            else if( !this.isError ) {
                                setTimeout(() => {
                                    document.location.reload();
                                }, this.reloadDelay);
                            }
                            else {
                                this.loading = false;

                                this.notifyBy(this.isError ? 'error' : 'success', { message: this.msg });
                            }

                            if( resp.status ) {
                                this.disableSubmit = true;
                            }
                        }
                    );
                }

            },

            validate() {
                let isInvalid = false;

                this.$children.forEach(( child ) => {
                    if( typeof child.checkIsValid === 'function' ) {
                        if( !child.checkIsValid() ) {
                            isInvalid = true;
                        }
                    }
                });

                this.isInvalid = isInvalid;

                return !isInvalid;
            },

        }
    }
</script>
